var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownFromLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.914 240H272V176C272 149.492 250.51 128 224 128H160C133.49 128 112 149.492 112 176V240H68.713C27.082 240 5.189 289.371 33.137 320.227L169.375 470.625C175.625 476.875 183.812 480 192 480S208.375 476.875 214.625 470.625L350.533 320.176C378.418 289.309 356.512 240 314.914 240ZM192 425.367L70.633 288H160V176H224V288H313.367L192 425.367ZM360 32H24C10.75 32 0 42.75 0 56S10.75 80 24 80H360C373.25 80 384 69.25 384 56S373.25 32 360 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownFromLine);
export default __webpack_public_path__ + "static/media/down-from-line.e336bf3585ebc66cb76779370cba4ca3.svg";
export { ForwardRef as ReactComponent };